import axios from 'axios';
const BASE_API = process.env.VUE_API_ROOT;

export default {
  formatMoney(dollars) {
    if(dollars.hasOwnProperty('cents')) { dollars = dollars.cents / 100; }
    return Intl.NumberFormat('en', {
      style: 'currency',
      currency: 'USD',
    }).format(dollars);
  },
  betterRound(number, places = 2) {
    return Number(`${Math.round(`${number}e${places}`)}e-${places}`)
  },
  htmlEncode(e) {
    return e.replace(/[^]/g,function(e){return"&#"+e.charCodeAt(0)+";"})
  },
  formatPhoneNumber(str) {
    let cleaned = ('' + str).replace(/\D/g, '');
    let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

    if (match) {
      let intlCode = (match[1] ? '+1 ' : '')
      return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
    }

    console.log('phone number didn\'t match US format, returning it unformatted')
    return str;
  },
  httpOk(code) {
    return code < 300 && code >= 200;
  },
  isObject(item) {
    return (item && typeof(item) === 'object' && !Array.isArray(item));
  },
  deepEntries(obj) {
    var allkeys, curKey = '[', len = 0, i = -1, entryK;

    function formatKeys( entries ){
      entryK = entries.length;
      len += entries.length;
      while (entryK--)
        entries[entryK][0] = curKey+JSON.stringify(entries[entryK][0])+']';
      return entries;
    }
    allkeys = formatKeys( Object.entries(obj) );

    while (++i !== len)
      if (typeof allkeys[i][1] === 'object' && allkeys[i][1] !== null){
        curKey = allkeys[i][0] + '[';
        Array.prototype.push.apply(
          allkeys,
          formatKeys( Object.entries(allkeys[i][1]) )
        );
      }
    return allkeys;
  },
  async timeout(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
  },
  waitResponse(uuid, successCallback, failureCallback, timeoutCallback, errorCallback, count = 0) {
    axios.get(`${BASE_API}/champ/request-status/${uuid}`)
      .then((response) => {
        if (response.data && response.data.Processed)
          if (response.data.ErrorCode !== 1000) failureCallback(response.data);
          else successCallback(response.data);
        else if (count >= 10) timeoutCallback()
        else setTimeout(() => {
          this.waitResponse(uuid, successCallback, failureCallback, timeoutCallback, errorCallback, count + 1);
        }, 1000);
      }).catch((error) => {
        errorCallback(error)
      });
  },
  toUpper(str) {
    return str.replace(/\b\w/, c => c.toUpperCase())
  },
  async queryPassthrough(query, args = [], database = 'fishbowl', getCsv = false) {
    return axios({
      method: 'POST',
      headers: { 'Content-Type': 'text/plain' },
      url: `${BASE_API}/${database}/passthrough${getCsv ? '.csv' : ''}`,
      data: { query, args },
    }).then((response) => {
      console.info(response.data);
      return response.data;
    }).catch((error) => {
      console.error(error);
    });
  },
  dig(obj, ...args) {
    if (!obj) {
      return null;
    }

    let head = obj
    args.forEach(k => {
      if (Object.keys(head).includes(k)) {
        head = head[k]
        if (!head) {
          return null
        }
      } else {
        return null
      }
    })

    return head
  }
};



// WEBPACK FOOTER //
// /src/helpers/utility.js